import { useQuery } from '@tanstack/react-query';
import type { OutputPeriod } from '@/lib/api';
import { outputApi } from '@/lib/api';

/**
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business プロジェクトアウトプット集計を取得するフック。期間の刻みごとにキャッシュする
 * @graph-connects outputApi [calls] アウトプットAPIクライアント呼び出し
 */
export function useOutputSummary(period: OutputPeriod) {
  return useQuery({
    queryKey: ['output', 'summary', period],
    queryFn: () => outputApi.getSummary(period),
    staleTime: 5 * 60 * 1000,
  });
}
